// Frontend is served as pure Vanilla HTML/CSS/JS from /public.
// React is intentionally rendered as null so the static markup in
// public/index.html (outside the #root div) is what the user sees.
function App() {
  return null;
}

export default App;
